export default __webpack_public_path__ + "static/media/briefIntroduction1.715874b2.png";